import { PRELOAD_DATA } from '../../../car/dataPreload/store/preload.action-types';
import { RESET_STATE } from '../../../wizard/store/wizard.action-types';
import { FULL_NAME_SAVE } from './fullName.action-types';

const INITIAL_STATE = {
  selected: {
    name: null,
    isCompany: false,
  },
};

const fullNameV2Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PRELOAD_DATA: {
      return reduceWithFullName(state, action.payload.person.fullName);
    }
    case RESET_STATE:
      return {
        ...state,
        selected: {
          name: null,
          isCompany: false,
        },
      };
    case FULL_NAME_SAVE:
      return reduceWithFullName(state, action.payload);
    default:
      return state;
  }
};

const reduceWithFullName = (state, fullName) => {
  return {
    ...state,
    selected: fullName,
  };
};

export default fullNameV2Reducer;